const supplier = {
  supplierNo: '编码',
  supplierName: '名称',
  tel: '联系电话',
  address: '联系地址',
  supplierType: '类型',
  contactPerson: '联系人',
  email: '邮箱',
  remark: '备注',
  transport3PL: '运输3PL',
  msg: {}
};
export default supplier;



// WEBPACK FOOTER //
// ./src/page/md/supplier/lang/supplier.zh.js